import Vue from 'vue';
// const VueMoment = () => import(/* webpackChunkName: "moment-vue" */ 'vue-moment')
// const momentTZ = () => import (/* webpackChunkName: "moment-timezone" */ 'moment-timezone')

import VueMoment from 'vue-moment';
import moment from 'moment';
import momentTZ from 'moment-timezone';

Vue.use(VueMoment, {
  moment: momentTZ,
});

const calSpec: any = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  lastDay: '[Yesterday]',
  nextWeek: 'dddd',
  lastWeek: '[last] dddd',
  sameElse: 'L',
};
momentTZ.setCalSpec = calSpec;



function DateRangeValue(dt: any) {
  if (!dt) { return {
    from: moment().add(-1, 'month').endOf('day'),
    to: moment().endOf('day')
  };
  }

  if (dt.from && dt.to) {
    return {
      from: moment(dt.from),
      to: moment(dt.to),
    };
  }
  switch (String(dt).toLowerCase()) {
    case "today":
      return {
        from: moment().add(-1, 'day').endOf('day'),
        to: moment().endOf('day')
      };
    case "yesterday":
      return {
        from: moment().add(-2, 'day').endOf('day'),
        to: moment().add(-1, 'day').endOf('day')
      };
    case "last-week":
      return {
        from: moment().add(-7, 'day').endOf('day'),
        to: moment().endOf('day')
      };
    case "last-month":
      return {
        from: moment().add(-1, 'month'),
        to: moment().endOf('day')
      };
    case "last-6-month":
      return {
        from: moment().add(-6, 'month'),
        to: moment().endOf('day')
      };
    case "last-year":
      return {
        from: moment().add(-1, 'year'),
        to: moment().endOf('day')
      };
  }

  return {
    from: moment().add(-1, 'month').endOf('day'),
    to: moment().endOf('day')
  };
}

export {
  moment,
  momentTZ,
  calSpec,
  DateRangeValue
};
